import { COLORS } from '@btime/constants'
import { formatDate } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { RefetchingIndicator } from '../../../../components/helpers/StatePresenter'
import { SmallText } from '../../../../packages/kiti/components/presentation/Text'
import { Text } from '../../../../components/presentation/Text'
import { triggersClient } from '../../../../utils/apollo/api'
import { useOpenTriggerCallModal } from '../../../../utils/routes/modals/modalsActions'
import { useRowActionsColumn } from '../../../../components/tables/Table'
import { useTriggerCalls } from '../_load/TriggerCallsLoader'
import { useTriggerCallsActions } from '../../_actions/triggerCallsActions'
import DataTable from '../../../../packages/kiti/components/table/DataTable'
import Link from '../../../../packages/kiti/components/actions/Link'
import ListCounter from '../../../../components/helpers/ListCounter'
import Tag from '../../../../components/presentation/Tag'
import TriggerSentence from '../../../../containers/triggers/TriggerSentence'

const TriggerCallsTable = () => {
  const { t } = useTranslation(['triggerCalls', 'common', 'webhook'])
  const data = useTriggerCalls()

  const openDetailsModal = useOpenTriggerCallModal()

  const columns = [
    {
      label: t('triggerCalls:name'),
      headerSideContent: (
        <>
          <ListCounter
            client={triggersClient}
            entity="triggerCalls"
            filterName="TriggerCallFilter"
            size="xsmall"
            bold
          />
          <RefetchingIndicator />
        </>
      ),
      dataIndex: 'data',
      sortIndex: false,
      flex: 4,
      render: (data, record) => (
        <Link onClick={() => openDetailsModal(record)}>
          <TriggerSentence trigger={data.trigger} />
        </Link>
      )
    },

    {
      label: t('webhook:status'),
      dataIndex: 'status',
      flex: 1,
      render: status => <Tag label={status} color={status === 'error' && COLORS.red} />
    },

    {
      label: t('triggerCalls:originEntity'),
      dataIndex: 'data',
      format: data => data?.record?.name || data?.record?.yearly_id,
      flex: 1,
      render: (name, record) => (
        <>
          <SmallText size="xxsmall">{record.entityType}</SmallText>
          <Text>{name}</Text>
        </>
      )
    },

    {
      label: t('triggerCalls:destinationEntity'),
      dataIndex: 'data',
      format: data => data?.result?.id,
      flex: 1,
      render: (id, record) => !!id && <Text>{t('triggerCalls:idLabel', { id })}</Text>
    },

    {
      label: t('triggerCalls:date'),
      dataIndex: 'updatedAt',
      format: formatDate('DD/MM/YYYY HH:mm'),
      flex: 1
    },

    {
      label: t('common:actions'),
      flex: 1,
      render: useRowActionsColumn(useTriggerCallsActions)
    }
  ]

  return <DataTable rowKey="id" columns={columns} data={data} inPanel size="medium" />
}

export default TriggerCallsTable
